import { COVERAGE_DELETE_STR } from "common/sf_strings";
import { optionsTrueFalse } from "helpers/sf_lead_constants";
import { getPrimaryTextClass } from "helpers/sf_utils";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Card, CardBody, Col, Label, Row, Table } from "reactstrap";
import { updateLeadDetails } from "store/leads/actions";
import DeleteModal from "../DeleteModal";
import LeadDatePicker from "./LeadDatePicker";
import LeadEditDropdown from "./LeadEditDropdown";
import { dynamicSort } from "helpers/sf_adgroup_helper";
import { updateProspectDetails } from "store/prospects/actions";
import { LEAD_TYPE_IDS } from "helpers/sf_constants";

const LeadCoverage = (props) => {
    const [deleteCoverageModal, setDeleteCoverageModal] = useState({ action: false, coverage: {} });
    const [lead_data, setLeadData] = useState({})
    const [optionsCarrier, setOptionsCarrier] = useState([])
    const { lead_id } = useParams();
    const { leads, carriers } = useSelector(state => ({
        leads: state.Leads.leads,
        carriers: state.insurance_carrier.carriers
    }));
    const dispatch = useDispatch();
    let detailsUpdater = updateLeadDetails
    if (props?.is_prospect) {
        detailsUpdater = updateProspectDetails
    }
    //Create a useeffect and get lead data from redux store from lead_id from useParams

    useEffect(() => {
        if (props?.lead_data) {
            setLeadData(props?.lead_data);

        }
    }, [leads, lead_id, props?.lead_data])

    // For Delete Coverage Modal
    const launchdeleteCoverageModal = (coverage) => {
        setDeleteCoverageModal({ action: true, coverage: coverage });
    };

    const onClickCoverageModal = (payload) => {
        // dispatch(deleteLeadcoverage({id: payload?.coverage?.id}));    
        setDeleteCoverageModal({ action: false, coverage: {} });
    };


    //   Set carriers options
    useEffect(() => {
        if (carriers.length) {
            const optCarriers = carriers.map(singleValue => ({ label: singleValue?.name, value: singleValue?.name }));
            optCarriers?.sort(dynamicSort('label'))
            setOptionsCarrier(optCarriers);
        }
    }, [carriers]);

    // Sub Component for Group Health Lead Type
    const GroupHealthLeadCoverage = () => {
        return (
            <Card>
                <CardBody className="pt-0">
                    <Row>
                        <div className="px-0">
                            <Table className="mb-0 text-black">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "33%" }}>
                                            <Col className="d-flex align-items-center pt-1 my-2">
                                                <i className={`bx fs-24 bx-check-shield ${getPrimaryTextClass()}`} />
                                                <div className="mx-2 fs-15 font-weight-semibold">
                                                    Existing Coverage
                                                </div>
                                                <div className="ms-1 fs-13 d-none text-sfblue font-weight-semibold align-self-end">
                                                    Edit
                                                </div>
                                            </Col>
                                        </td>
                                        <td></td>
                                        <td style={{ width: "33%" }}>
                                            <Col
                                                className={`${getPrimaryTextClass()} d-none pt-1 my-2 font-weight-semibold`}
                                            >
                                                <a
                                                    className={`d-flex align-items-end ${getPrimaryTextClass()}`}
                                                    onClick={() =>
                                                        launchdeleteCoverageModal(lead_data?.lead_detail)
                                                    }
                                                >
                                                    <i className="mdi mdi-close me-2" />
                                                    Remove
                                                </a>
                                            </Col>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <Label className="mb-0 font-weight-semibold me-2">
                                                    Requested Coverage
                                                </Label>
                                                <div className="d-flex align-items-center">
                                                    <LeadEditDropdown
                                                        title='Requested Coverage'
                                                        field={lead_data?.lead_detail?.requested_coverage}
                                                        defaultValue={lead_data?.lead_detail?.requested_coverage}
                                                        isProspect={props?.is_prospect}
                                                        onSave={(value) => {
                                                            let data = {}
                                                            data.id = lead_data?.lead_detail?.id
                                                            data.requested_coverage = value
                                                            dispatch(detailsUpdater({ lead_details: data }))
                                                        }}
                                                        onCancel={() => { }}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                        <td style={{ width: "50%" }}>
                                            <div className="d-flex align-items-center">
                                                <Label className="mb-0 font-weight-semibold me-2">
                                                    Currently Insured
                                                </Label>
                                                <div className="d-flex align-items-center">
                                                    <LeadEditDropdown
                                                        isBoolean={true}
                                                        isDropdown={true}
                                                        options={optionsTrueFalse}
                                                        title="Currently Insured"
                                                        field={lead_data?.lead_detail?.insured}
                                                        onSave={(value) => {
                                                            let data = {}
                                                            data.id = lead_data?.lead_detail?.id
                                                            data.insured = value
                                                            dispatch(detailsUpdater({ lead_details: data }))
                                                        }}
                                                        onCancel={() => { }}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ width: "50%" }}>
                                            <div className="d-flex align-items-center">
                                                <Label className="mb-0 font-weight-semibold me-2">
                                                    Current Insurer
                                                </Label>
                                                <div className="d-flex align-items-center">
                                                    <LeadEditDropdown
                                                        isDropdown={true}
                                                        options={optionsCarrier}
                                                        title="Current Insurer"
                                                        field={lead_data?.lead_detail?.insco}
                                                        onSave={(value) => {
                                                            let data = {}
                                                            data.id = lead_data?.lead_detail?.id
                                                            data.insco = value
                                                            dispatch(detailsUpdater({ lead_details: data }))
                                                        }}
                                                        onCancel={() => { }}
                                                    />
                                                </div>
                                            </div>
                                        </td>

                                        <td style={{ width: "50%" }}>
                                            <div className="d-flex align-items-center">
                                                <Label className="mb-0 font-weight-semibold me-2">
                                                    Coverage Start
                                                </Label>
                                                <div className="d-flex align-items-center">
                                                    <LeadDatePicker
                                                        title="Coverage Start"
                                                        field={lead_data?.lead_detail?.requested_coverage_start_date}
                                                        onSave={(value) => {
                                                            let data = {}
                                                            data.id = lead_data?.lead_detail?.id
                                                            data.requested_coverage_start_date = value
                                                            dispatch(detailsUpdater({ lead_details: data }))
                                                        }}
                                                        onCancel={() => { }}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </Row>
                </CardBody>
            </Card>
        );
    };

    const LeadCoverage = () => {
        return (
            <Card>
                <CardBody className="pt-0">
                    <Row>
                        <div className="px-0">
                            <Table className="mb-0 text-black">
                                <tbody id="existing_coverage">
                                    <tr>
                                        <td style={{ width: "33%" }}>
                                            <Col className="d-flex align-items-center pt-1 my-2">
                                                <i className={`bx fs-24 bx-check-shield ${getPrimaryTextClass()}`} />
                                                <div className="mx-2 fs-15 font-weight-semibold">
                                                    Existing Coverage
                                                </div>
                                                <div className="ms-1 fs-13 d-none text-sfblue font-weight-semibold align-self-end">
                                                    Edit
                                                </div>
                                            </Col>
                                        </td>
                                        <td></td>
                                        <td style={{ width: "33%" }}>
                                            <Col
                                                className={`${getPrimaryTextClass()} d-none pt-1 my-2 font-weight-semibold`}
                                            >
                                                <a
                                                    className={`d-flex align-items-end ${getPrimaryTextClass()}`}
                                                    onClick={() =>
                                                        launchdeleteCoverageModal(lead_data?.lead_detail)
                                                    }
                                                >
                                                    <i className="mdi mdi-close me-2" />
                                                    Remove
                                                </a>
                                            </Col>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ width: "33%" }}>
                                            <div className="d-flex align-items-center">
                                                <Label className="mb-0 font-weight-semibold me-2">
                                                    Currently Insured
                                                </Label>
                                                <div className="d-flex align-items-center">
                                                    <LeadEditDropdown
                                                        isBoolean={true}
                                                        isDropdown={true}
                                                        options={optionsTrueFalse}
                                                        title="Currently Insured"
                                                        field={lead_data?.lead_detail?.insured}
                                                        isContinuousCoverage={
                                                            lead_data?.lead_detail?.continuous_insurance
                                                        }
                                                        onSave={(value) => {
                                                            let data = {}
                                                            data.id = lead_data?.lead_detail?.id
                                                            data.insured = value
                                                            dispatch(detailsUpdater({ lead_details: data }))
                                                        }}
                                                        onCancel={() => { }}
                                                    />
                                                </div>
                                            </div>
                                        </td>

                                        <td style={{ width: "33%" }}>
                                            <div className="d-flex align-items-center">
                                                <Label className="mb-0 font-weight-semibold me-2">
                                                    Policy Expires
                                                </Label>
                                                <div className="d-flex align-items-center">
                                                    <LeadDatePicker
                                                        title="Insured Since"
                                                        field={lead_data?.lead_detail?.policy_expiration_dt}
                                                        onSave={(value) => {
                                                            let data = {}
                                                            data.id = lead_data?.lead_detail?.id
                                                            data.policy_expiration_dt = value
                                                            dispatch(detailsUpdater({ lead_details: data }))
                                                        }}
                                                        onCancel={() => { }}
                                                    />
                                                </div>
                                            </div>
                                        </td>

                                        <td style={{ width: "33%" }}>
                                            <div className="d-flex align-items-center">
                                                <Label className="mb-0 font-weight-semibold me-2">
                                                    Carrier
                                                </Label>
                                                <div className="d-flex align-items-center">
                                                    <LeadEditDropdown
                                                        isDropdown
                                                        options={optionsCarrier}
                                                        title="Carrier"
                                                        field={lead_data?.lead_detail?.insco}
                                                        onSave={(value) => {
                                                            let data = {}
                                                            data.id = lead_data?.lead_detail?.id
                                                            data.insco = value
                                                            dispatch(detailsUpdater({ lead_details: data }))
                                                        }}
                                                        onCancel={() => { }}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <Label className="mb-0 font-weight-semibold me-2">
                                                    Continuous Insurance
                                                </Label>
                                                <div className="d-flex align-items-center">
                                                    <LeadEditDropdown
                                                        isInput={true}
                                                        title='Continuous Insurance'
                                                        field={lead_data?.lead_detail?.continuous_insurance}
                                                        currentlyInsured={lead_data?.lead_detail?.insured}
                                                        isProspect={props?.is_prospect}
                                                        onSave={(value) => {
                                                            let data = {}
                                                            data.id = lead_data?.lead_detail?.id
                                                            data.continuous_insurance = value
                                                            dispatch(detailsUpdater({ lead_details: data }))
                                                        }}
                                                        onCancel={() => { }}
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                        <td colspan="2">
                                            {(lead_data?.lead_type_id === LEAD_TYPE_IDS.COMMERCIAL) && (
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Requested Coverage
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            title='Requested Coverage'
                                                            field={lead_data?.lead_detail?.requested_coverage}
                                                            defaultValue={lead_data?.lead_detail?.requested_coverage}
                                                            isProspect={props?.is_prospect}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = lead_data?.lead_detail?.id
                                                                data.requested_coverage = value
                                                                dispatch(detailsUpdater({ lead_details: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </Row>
                </CardBody>
            </Card>
        );
    };

    return (
        <React.Fragment>
            <DeleteModal
                deleteModalState={deleteCoverageModal}
                onDeleteClick={onClickCoverageModal}
                textMessage={COVERAGE_DELETE_STR}
                onCloseClick={() => setDeleteCoverageModal({ action: false, coverage: {} })}
                cancelButton
            />
            {lead_data?.lead_type_id === LEAD_TYPE_IDS.GROUP_HEALTH ?
                <GroupHealthLeadCoverage /> :
                <LeadCoverage />
            }
        </React.Fragment>
    )
}

export default LeadCoverage;